import Reveal from "@/components/Reveal";

const HomeTeam = ({ content, galleryImages }) => {
  const img1 = content?.image_url_1 || galleryImages?.[0]?.url || "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&q=80";
  const img2 = content?.image_url_2 || galleryImages?.[1]?.url || "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&q=80";

  return (
    <section className="py-24 md:py-36 bg-transparent overflow-hidden">
      <div className="sm-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-8 items-center">
          
          {/* Text Left */}
          <div className="relative pl-8 md:pl-12 lg:pr-16 z-10">
            <div className="absolute left-0 top-0 bottom-0 w-px bg-sm-gold" />
            <Reveal>
              <p className="sm-eyebrow mb-6">{content?.eyebrow}</p>
              <h2 className="font-serif text-4xl md:text-5xl text-sm-text font-light leading-tight mb-8">
                {content?.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-base text-sm-muted font-light leading-relaxed mb-6">
                {content?.bio_1}
              </p>
              <p className="text-base text-sm-muted font-light leading-relaxed">
                {content?.bio_2}
              </p>
            </Reveal>
          </div>

          {/* Images Right - Overlapping */}
          <div className="relative h-[500px] lg:h-[700px] w-full mt-10 lg:mt-0">
            <Reveal delay={0.2} className="absolute top-0 right-0 w-[70%] h-[75%] z-0">
              <img 
                src={img1} 
                alt="Ekipi 1" 
                className="w-full h-full object-cover grayscale-[20%]"
              />
            </Reveal>
            <Reveal delay={0.3} className="absolute bottom-0 left-0 w-[60%] h-[60%] z-10 shadow-2xl">
              <img 
                src={img2} 
                alt="Ekipi 2" 
                className="w-full h-full object-cover grayscale-[20%]"
              />
            </Reveal>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeTeam;
